var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImportIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 17.999C13.7758 17.999 14 17.7748 14 17.499V7.49902C14 7.22324 13.7758 6.99902 13.5 6.99902H10C9.72422 6.99902 9.5 7.22324 9.5 7.49902C9.5 7.7748 9.72422 7.99902 10 7.99902H13V16.999H3V7.99902H6C6.27578 7.99902 6.5 7.7748 6.5 7.49902C6.5 7.22324 6.27578 6.99902 6 6.99902H2.5C2.22422 6.99902 2 7.22324 2 7.49902V17.499C2 17.7748 2.22422 17.999 2.5 17.999H13.5Z",
    fill: "#2F80ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 2.50162V12.1656L6.12194 10.6352C5.9368 10.4305 5.62116 10.4133 5.4157 10.5984C5.21023 10.7828 5.19382 11.0984 5.3782 11.3039L7.668 13.8461C7.8516 14.05 8.14847 14.05 8.33206 13.8461L10.6219 11.3039C10.8062 11.0984 10.7898 10.7828 10.5844 10.5984C10.3789 10.4133 10.0633 10.4305 9.87812 10.6352L8.5 12.1656V2.50162C8.5 2.2196 8.27578 2.00005 8 2.00005C7.72188 2.00005 7.5 2.22428 7.5 2.50162Z",
    fill: "#2F80ED"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportIcon);
export default __webpack_public_path__ + "static/media/import-icon.417447244c913193c2db5286978d09f1.svg";
export { ForwardRef as ReactComponent };